const initialState = {
  active: 0,
  duplicate: false,
  newSegmentationModal: false,
  deleteLoading: false,
  renameDone: false,
  renameLoading: false,
  segmentationName: '',
  segmentation: {},
  segmentations: []
};

export { initialState };
